/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_TimeInputs */

const en_notify_time = /** @type {(inputs: Notify_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const de_notify_time = /** @type {(inputs: Notify_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhrzeit`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Notify_TimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_time = /** @type {((inputs?: Notify_TimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_TimeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_time(inputs)
	return en_notify_time(inputs)
});